import { withStyles, WithStyles } from "@mui/styles";
import { FeedStyleClasses } from "assets/jss/common-styles";
import MediaUtils from "lib/MediaUtils";
import { PublicationType } from "models/ApiEnums";
import { FeedItemBestAnswerDto, FeedItemBodyDto } from "models/ApiModels";
import { AttachType } from "models/AppModels";
import * as React from "react";
import AttachMetadataBox from "views/Publication/Components/AttachMetadataBox";
import BodyTextExpand from "views/Timeline/Components/CardComp/BodyTextExpand";
import { CardBodyData } from "views/Timeline/Components/CardLib/CardBodyData";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    publicationType: PublicationType;
    body: FeedItemBodyDto;
    bestAnswer: FeedItemBestAnswerDto;
}

type Props = IProps & WithStyles<typeof FeedStyleClasses>;

/////////////////////////////////////////////////////////////////////////////////////

class PublicationAdminBody extends React.PureComponent<Props, IState> {

    private data: CardBodyData;

    private renderBody() {
        const { classes, } = this.props;

        const showAttach =
            this.data.metadata != null
            ||
            (this.data.attachs && (this.data.attachs.length > 1 || (this.data.attachs.length == 1 && MediaUtils.getAttachTypeFromMimeType(this.data.attachs[0].mainFile.mimeType) != AttachType.Image)));

        return (
            <div className={classes.cardBody}>

                <div className={"clearfix"}>

                    {
                        this.data.isLinkOnly()
                            ? null
                            : <BodyTextExpand
                                classes={classes}
                                text={this.data.content}
                            />
                    }

                </div>

                {
                    showAttach &&
                    <AttachMetadataBox
                        fileOrLink={this.data.metadata || this.data.nonEmbedAttachs}
                    />
                }
            </div>
        );
    }

    render() {

        this.data = new CardBodyData(this.props, false, true);

        return this.renderBody();
    }
}

export default withStyles(FeedStyleClasses)(PublicationAdminBody);
